import { useMutation } from '@tanstack/react-query';
import { saveAs } from 'file-saver';

import { useSnackbarNotification } from '@store/snackbarNotification';
import exportSellout from '@data/selloutMonitoring/exportSellout';
import getExportSelloutRequest from '@domain/model/request/selloutMonitoring/getExportSelloutRequest';
import { useFilter } from '../state/filters';

export const useMutateExportSellout = () => {
    const localFilter = useFilter();
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    return useMutation({
        mutationFn: async (filters) => {
            onChangeSnackbarNotification({
                status: 'info',
                title: 'Proses Download Data',
                description: (
                    <>
                        Silahkan menunggu, sedang mengunduh <b>Sellout-Monitoring.{localFilter?.type}</b>
                    </>
                ),
                duration: 5,
            });

            const queries = getExportSelloutRequest(filters);
            const data = await exportSellout(queries);
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            saveAs(blob, `Sellout-Monitoring.${localFilter?.type}`);
        },
        onSuccess: async () => {
            onChangeSnackbarNotification({
                status: 'success',
                title: 'Sukses Download Data',
                description: (
                    <>
                        <b>Sellout-Monitoring.{localFilter?.type}</b> berhasil diunduh
                    </>
                ),
                duration: 5,
            });
        },
        onError: async (error) => {
            let errorMessage = error.message || 'Terjadi gangguan pada saat proses download data sellout';
            if (error instanceof AxiosError && error.response?.data instanceof Blob) {
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                errorMessage = json?.message ?? errorMessage;
            }

            onChangeSnackbarNotification({
                status: 'error',
                title: 'Export Gagal',
                description: errorMessage,
                duration: 3,
            });
        },
    });
};
